// @flow

import { observer } from "mobx-react";
import React from "react";
import TimeAgo from "react-timeago";

import TimelineItemComment from "app/models/TimelineItemComment";
import UserThumbnail from "app/components/UserThumbnail/UserThumbnail";

import ConfirmationModal from "app/components/ConfirmationModal/ConfirmationModal";
import Icon from "app/components/Icon/Icon";

import "./TimelineCardComment.scss";

type Props = {
    comment: TimelineItemComment,
    deletable: boolean,
    onDelete: Function,
    serverTime: any
};

type State = {
    deleting: boolean
};

@observer
export default class TimelineCardComment extends React.Component<
    Props,
    State
> {
    constructor(props: Props) {
        super(props);
        this.state = { deleting: false };
    }

    handleDelete() {
        this.setState({ deleting: true });
    }

    handleCancelDelete() {
        this.setState({ deleting: false });
    }

    getUserProfileUrl() {
        return "/u/" + this.props.comment.author_slug;
    }

    render() {
        const comment = this.props.comment;

        return (
            <div className="TimelineCardComment">
                <div className="TimelineCardComment__message">
                    <a href={this.getUserProfileUrl()}>
                        <UserThumbnail name={this.props.comment.author_name} image={this.props.comment.author_image} />
                        &nbsp; {this.props.comment.author_name}
                    </a>
               
                    : {comment.message}
                    <div className="TimelineCardComment__time">
                        <TimeAgo
                            date={comment.send_time}
                            now={() => this.props.serverTime}
                            title={comment.send_time}
                        />
                    </div>
                </div>

                <div className="TimelineCardComment__delete">
                    {this.renderDeleteCommentButton()}
                </div>

                {this.renderDeleteConfirmation()}
            </div>
        );
    }

    renderDeleteCommentButton() {
        if (!this.props.deletable) return null;

        return (
            <button
                className="TimelineCardComment__delete-button"
                onClick={this.handleDelete.bind(this)}
            >
                <Icon name="trash-o" fontAwesome={true} />
            </button>
        );
    }

    renderDeleteConfirmation() {
        if (!this.state.deleting) return null;

        return (
            <ConfirmationModal
                message="Are you sure you want to delete this comment?"
                actionText="Delete comment"
                onConfirm={this.props.onDelete}
                onCancel={this.handleCancelDelete.bind(this)}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardComment/TimelineCardComment.js